export default __webpack_public_path__ + "static/media/task16desktoppluspopupnew.5854a7e8.png";